import React, { useEffect, useState, useContext } from "react";
import Modal from "react-modal";
import "../../../../UcafForm/styles.css";
import myImage from "../../../../UcafForm/target001.png";
import DentalSelctedTooth from "./DentalSelctedTooth";
import { useTranslation } from "react-i18next";
import { printElementToPdf } from "../../../../UcafForm/printUtils";
import { appContext } from "../../../../context/ContextProvider";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minHeight: "90%",
    maxHeight: "90%",
    minWidth: "90%",
  },
};

export function DCAFData({ item }) {
  const { user } = useContext(appContext);
  const loggedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  })();

  const providerName =
    item?.provider_name ||
    item?.provider?.full_name ||
    item?.provider?.name ||
    item?.provider_name_en ||
    loggedUser?.FullName ||
    loggedUser?.full_name ||
    user?.FullName ||
    "";

  const headerOne = [
    { id: 1, name: "Code" },
    { id: 2, name: "Dental Service" },
    { id: 3, name: "Tooth No." },
    { id: 4, name: "Cost" },
  ];
  const headerthree = [
    { id: 1, name: "Code" },
    { id: 2, name: "Reject Reason Code" },
    { id: 3, name: "Reject Reason Description" },
  ];
  const headerTwo = [
    { id: 1, name: "Medication Name (Generic Name)" },
    { id: 2, name: "Type" },
    { id: 3, name: "Quantity" },
  ];
  const headerTwoData = [
    { id: 1, name: "Medication Name (Generic Name)" },
    { id: 2, name: "Type" },
    { id: 3, name: "Quantity" },
  ];

  const calculateTotalNet = () => {
    return (
      item?.items
        // ?.filter((item) => item.type === "oral-health-op")
        ?.reduce((accumulator, currentItem) => accumulator + currentItem.net, 0)
    );
  };

  // Compact data display component
  const CompactDataRow = ({ label, value, className = "" }) => (
    <div className={`flex items-center gap-1 ${className}`}>
      <span className="text-xs font-semibold whitespace-nowrap">{label}:</span>
      <span className="text-xs border-b border-dotted border-black flex-1 min-w-[50px] truncate">
        {value || ""}
      </span>
    </div>
  );

  return (
    <div
      className="print-container"
      style={{ fontSize: "12px", lineHeight: "1.2" }}
    >
      <h3 className="text-lg text-center font-bold mb-2">DCAF 2.0</h3>

      {/* First Row - Compact Grid */}
      <div className="grid grid-cols-2 gap-1 mb-2">
        {/* Reception/Nurse Section */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-xs font-bold mb-1">
            To be completed &amp; ID verified by the reception/nurse:
          </h3>
          <div className="space-y-1">
            <CompactDataRow label="Provider Name" value={providerName} />
            <CompactDataRow
              label="Insurance Company"
              value={item?.payer_name}
            />
            <CompactDataRow label="TPA Company" value={item?.tpa_name} />
            <CompactDataRow
              label="Patient Document ID"
              value={item?.patient_document_id}
            />
            <div className="flex items-center gap-1">
              <span className="text-xs font-semibold">
                Single () Married ():
              </span>
              <span className="text-xs">Plan Type</span>
              <span className="text-xs border-b border-dotted border-black flex-1">
                {item?.insurance_plan?.coverage_type}
              </span>
            </div>
            <CompactDataRow label="Date Of Visit" value="No" />
            <div className="flex gap-2 text-xs">
              <span>New Visit()</span>
              <span>FollowUp()</span>
              <span>Refell()</span>
              <span>WalkIn()</span>
            </div>
            <div className="flex gap-2">
              <CompactDataRow
                label="Referrel"
                value={item?.is_referral ? "Yes" : "No"}
                className="flex-1"
              />
              <CompactDataRow
                label="Refer To"
                value={item?.refer_to ||item?.reffered_hospital || ""}
                className="flex-1"
              />
            </div>
          </div>
        </div>

        {/* Patient Info Section */}
        <div className="border border-black p-1 rounded">
          <h3 className="text-xs font-bold mb-1">
            Print &amp; fill in clear letters or Emboss Card:
          </h3>
          <div className="space-y-1">
            <CompactDataRow
              label="Insured Name"
              value={item?.patient?.full_name}
            />
            <CompactDataRow
              label="ID Card Number"
              value={item?.insurance_plan?.member_card_id}
            />
            <div className="flex gap-1">
              <CompactDataRow
                label="Sex"
                value={item?.patient?.gender}
                className="flex-1"
              />
              <CompactDataRow
                label="Date of Birth"
                value={item?.patient?.dob}
                className="flex-1"
              />
            </div>
            <div className="flex gap-1">
              <CompactDataRow label="Policy Holder" value="YES" className="flex-1" />
              <CompactDataRow
                label="Policy Number"
                value={item?.insurance_plan?.policy_number}
                className="flex-1"
              />
            </div>
            <div className="flex gap-1">
              <CompactDataRow
                label="Date Of Expiry"
                value={item?.insurance_plan?.expiry_date}
                className="flex-1"
              />
              <CompactDataRow
                label="Class"
                value={item?.className}
                className="flex-1"
              />
            </div>
            <div className="flex gap-1">
              <CompactDataRow
                label="Approval"
                value={item?.pre_auth_ref_no}
                className="flex-1"
              />
              <CompactDataRow
                label="Response Date"
                value={
                  !(item?.status === "approved")
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null
                }
                className="flex-1"
              />
            </div>
            <div className="flex gap-1">
              <CompactDataRow
                label="Approval Status"
                value={item?.status}
                className="flex-1"
              />
              <CompactDataRow
                label="Approval Date"
                value={
                  item?.status === "approved"
                    ? item?.response_date && item?.response_date?.length > 16
                      ? item?.response_date.substring(0, 16).replace("T", " ")
                      : item?.response_date
                    : null
                }
                className="flex-1"
              />
            </div>
            <div className="flex items-start gap-1">
              <span className="text-xs font-semibold whitespace-nowrap">
                Remarks:
              </span>
              <span className="text-xs border-b border-dotted border-black flex-1 break-words">
                {item?.disposition}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Dentist Section */}
      <div className="border border-black p-1 rounded mb-1">
        <div className="grid grid-cols-7 gap-1">
          <div className="col-span-4">
            <h3 className="text-xs font-bold mb-1">
              To be completed by Dentist
            </h3>

            <div className="flex items-center gap-1 mb-1">
              <span className="text-xs font-semibold whitespace-nowrap">
                Duration of Illness :
              </span>
              <span className="text-xs border-b border-dotted border-black flex-1 min-w-[50px]"></span>
              <span className="text-xs font-semibold">(Days)</span>
            </div>

            <div className="mb-1">
              <div className="flex items-start">
                <span className="text-xs font-semibold whitespace-nowrap mr-1">
                  Chief Complaints and Main Symptoms:
                </span>
                <div className="text-xs border-b border-dotted border-black flex-1">
                  {item?.supporting_info
                    ?.filter((support) => support?.category === "chief-complaint")
                    ?.map((support) => (
                      <p key={support?.sequence_no} className="font-semibold">
                        {/* {support?.code} */} {support?.code_text} {support?.value}
                      </p>
                    ))}
                </div>
              </div>
            </div>

            <div className="space-y-1 mb-1">
              <CompactDataRow label="Significant Signs" value="" />
              <CompactDataRow label="Other Conditions" value="" />
              <CompactDataRow
                label="Diagnosis"
                value={item?.diagnosis
                  .map((diag) => {
                    return `${diag.code} - ${diag.description}`;
                  })
                  .join(", ")}
              />
              <CompactDataRow
                label="Principal Code"
                value={item?.diagnosis
                  .map((diag) => {
                    return `${diag.code}`;
                  })
                  .join(", ")}
              />
            </div>

            <hr className="border-black my-1" />

            <h3 className="text-xs font-bold mb-1">
              Please tick () Where appropriate
            </h3>
            <div className="text-xs space-y-1">
              <div className="flex gap-2">
                <span>Regular Dental Treatment ()</span>
                <span>Dental Cleaning ()</span>
              </div>
              <div className="flex gap-2 items-center">
                <span>Trauma Treatment Specify: RTA ()</span>
                <span>Work Related ()</span>
                <div className="flex items-center gap-1">
                  <span>Other</span>
                  <span className="text-xs border-b border-dotted border-black w-12"></span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-3 flex justify-center items-center">
            <div className="scale-75">
              <DentalSelctedTooth item={item} />
            </div>
          </div>
        </div>

        {/* Procedures Table */}
        <div className="mt-1">
          <p className="text-xs mb-1">
            Specify the recommended procedures using the tooth number as shown
            on the teeth map above:
          </p>

          <table className="w-full border border-black text-xs">
            <thead>
              <tr className="border border-black">
                {headerOne.map((item, index) => (
                  <th
                    key={index}
                    className="border border-black p-1 text-center font-bold"
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((item, index) => (
                <tr key={index} className="border border-black">
                  <td className="border border-black p-1 text-center">
                    {item?.standard_code}
                  </td>
                  <td className="border border-black p-1 text-center">
                    <div>{item?.standard_description}</div>
                    {item?.reject_reason_display ? (
                      <div className="text-xs text-red-500 mt-1">
                        <span className="font-semibold">Reject Reason: </span>
                        {item?.reject_reason_display}
                      </div>
                    ) : null}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.body_site}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.net}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="border border-black">
                <td colSpan="2"></td>
                <td className="border border-black p-1 text-center font-bold">
                  Total
                </td>
                <td className="border border-black p-1 text-center font-bold">
                  {calculateTotalNet()}
                </td>
              </tr>
            </tfoot>
          </table>

          <p className="text-xs font-semibold mt-1">
            Providing approvals /Coding Stff must review /Code the recommended
            Service and collect cose and complete the follwing :
          </p>

          <div className="flex gap-1 mt-1">
            <CompactDataRow
              label="Completed / Coded By"
              value=""
              className="flex-1"
            />
            <CompactDataRow label="Signature" value="" className="flex-1" />
            <CompactDataRow label="Date" value="" className="flex-1" />
          </div>

          {/* Medications Table */}
          <table className="w-full border border-black text-xs mt-1">
            <thead>
              <tr className="border border-black">
                {headerTwo.map((item, index) => (
                  <th
                    key={index}
                    className="border border-black p-1 text-center font-bold"
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {item?.items?.map((item, index) => (
                <tr key={index} className="border border-black">
                  <td className="border border-black p-1 text-center">
                    {`(${item?.standard_code}) - ${item?.standard_description}`}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.type}
                  </td>
                  <td className="border border-black p-1 text-center">
                    {item?.quantity}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs">
              In Case management form (CMF 1.0) included
            </span>
            <b className="text-xs">Yes () No()</b>
          </div>

          <div className="flex items-center gap-1 mt-1">
            <span className="text-xs whitespace-nowrap">
              Please specify Possible line of management when applicable:
            </span>
            <span className="text-xs border-b border-dotted border-black flex-1"></span>
          </div>

          <div className="flex gap-1 mt-1">
            <CompactDataRow
              label="Estimated length of Stay"
              value=""
              className="flex-1"
            />
            <CompactDataRow
              label="Estimated length of Stay"
              value=""
              className="flex-1"
            />
          </div>
        </div>
      </div>

      {/* Certifications */}
      <div className="border border-black p-1 rounded mb-1">
        <div className="flex gap-1">
          <div className="flex-1 border-r border-gray-300 pr-1">
            <p className="text-xs font-semibold">
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary.
            </p>
            <div className="flex justify-between mt-1 text-xs">
              <div className="flex flex-col">
                <span className="font-bold">Dentist</span>
                <span className="border-b border-dotted border-black w-20">
                  {item?.care_teams
                    .map((care) => {
                      return `${care.name}`;
                    })
                    .join(", ")}
                </span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Signature</span>
                <span className="border-b border-dotted border-black w-16"></span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Stamp</span>
                <input type="radio" className="scale-75" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold">Date</span>
                <span className="border-b border-dotted border-black w-16"></span>
              </div>
            </div>
          </div>

          <div className="flex-1 pl-1">
            <p className="text-xs font-semibold">
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </p>
            <div className="mt-1 text-xs">
              <CompactDataRow
                label="Name (and relationship (if guardian))"
                value=""
              />
              <div className="flex gap-1 mt-1">
                <CompactDataRow label="Signature" value="" className="flex-1" />
                <CompactDataRow label="Date" value="" className="flex-1" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Insurance Company Section */}
      <div className="border border-black p-1 rounded">
        <div className="text-xs">
          <div className="flex gap-1">
            <span className="font-semibold w-1/4">
              For Insurance Company Use Only:
            </span>
            <div className="flex w-3/4 justify-between">
              <span>Approved ( )</span>
              <span>Not Approved ( )</span>
              <span>Approval No:</span>
              <span>Approval validity:</span>
            </div>
          </div>
          <div className="mt-1">
            Days Comments (include approved days/services if different from the
            requested):
          </div>
        </div>

        <hr className="border-black my-1" />

        <div className="flex gap-1 text-xs">
          <CompactDataRow
            label="Approved/Disapproved By"
            value=""
            className="flex-1"
          />
          <CompactDataRow label="Signature" value="" className="flex-1" />
          <CompactDataRow label="Date" value="" className="flex-1" />
        </div>
      </div>

      <p className="text-xs font-bold mt-1">
        (*) This is applicable only in case of manual DCAF
      </p>
    </div>
  );
}

function DcafForm({ showDCAF, setShowDCAF, item }) {
  const { t } = useTranslation();
  const handlePrint = () => {
    setShowDCAF(false);

    setTimeout(() => {
      const printContent = document.getElementById("print-content");
      if (!printContent) return;
      printElementToPdf("dcaf", printContent);
    }, 300);
  };

  return (
    <Modal
      // isOpen={true}
      isOpen={showDCAF}
      onRequestClose={() => setShowDCAF(false)}
      style={customStyles}
      overlayClassName="fullscreen-modal-overlay fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999]"
      contentLabel="Example Modal"
    >
      <div id="print-content">
        <DCAFData item={item} />
      </div>
      <div className="sticky bottom-0 p-4 pt-3">
        <div className="flex justify-end">
          <button
            type="button"
            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => setShowDCAF(!showDCAF)}
          >
            {t("Close")}
          </button>
          <button
            type="submit"
            className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-[#0070C2] py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={() => handlePrint()}
          >
            {t("Print")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DcafForm;
